import { createBrowserRouter } from "react-router-dom";
import MainLayout from "../pages/MainLayout";
import Home from "../pages/Home/Home";
import Catalogo from "../pages/Catalogo/Catalogo";

const routesMap = {
  HOME_PAGE: "/",
  CATALOGO: "/catalogo",
};

const routerInstance = createBrowserRouter(
  [
    {
      path: "/",
      element: <MainLayout />,
      children: [
        {
          path: routesMap.HOME_PAGE,
          element: <Home />,
        },
        {
          path: routesMap.CATALOGO,
          element: <Catalogo />,
        },
      ],
    },
  ],
  { basename: "/catalogo-prodotti/spa-noauth" }
);

export { routerInstance, routesMap };
